/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ConfigProviderProps } from './types/config-provider-props';
import { ConfigContextProps } from './types/config-context-props';
import { useDesktop } from '@revenuewell/logic-desktop';

export const ConfigContext = createContext<ConfigContextProps>(null!);

export function ConfigProvider(props: React.PropsWithChildren<ConfigProviderProps>) {
    const [config, setConfig] = useState<any>(null);
    const [configHash] = useState<number>(new Date().getTime())
    const { isDesktopApplication } = useDesktop();

    useEffect(() => {
        loadConfig();
    }, []);

    const adjustConfig = (config: any) => {
        if(isDesktopApplication() && config?.oidc?.client_id_desktop) {
            config.oidc.client_id = config.oidc.client_id_desktop;
        }

        return config;
    }

    const loadConfig = () => {
        if(props.isProduction) {
            fetchProgConfig();
        } else {
            setConfig(adjustConfig(props.devConfig));
        }
    }

    const fetchProgConfig = () => {
        fetch(`${props.prodConfigPath}?_=${configHash}`)
            .then(file => {
                file.json()
                    .then(cfg => setConfig(adjustConfig(cfg)))
                    .catch(error => {
                        const message = `Unable to parse application configuration file.
                        Config path: ${props.prodConfigPath}.
                        Error: ${error}`;
                        throw new Error(message);
                    })
            })
            .catch(error => {
                const message = `Unable to fetch application configuration file.
                    Config path: ${props.prodConfigPath}.
                    Error: ${error}`;
                throw new Error(message);
            });
    }

    const context = {
        config: config
    } as ConfigContextProps;

    return <ConfigContext.Provider value={{ ...context }}>{ config ? props.children : null }</ConfigContext.Provider>;
}

export function useConfig() {
    const context = useContext(ConfigContext);

    if (!context) {
        throw new Error('useConfig must be used within the ConfigProvider');
    }

    return context;
}
